import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/classes/page';
import { ToastService } from 'src/app/toast/toast.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FinalChecklistService } from 'src/app/services/finalchecklist.service';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-audit-fees',
  templateUrl: './audit-fees.component.html',
  styleUrls: ['./audit-fees.component.scss']
})

export class AuditFeesComponent implements OnInit {
  AuditStatus: any[] = [];
  iSocietyDetailsId: any;
  page = new Page();
  loading = false;
  columns: any[] = [];
  id: number | null = null;
  filteredRows: any[] = [];
  rows: any[] = [];
  allDataLoaded = false;
  filteredData: any;
  societyTypeList = {
    iSocietyTypeId: 0,
    rateOfProfit: null,
    minumum: null,
    maximum: null,
    sName: ''
  }
  filter: any = { typeOfSociety: '', sName: '', keyword: '' };
  @ViewChild('formRef') formRef!: NgForm;
  constructor(
    private finalchecklist: FinalChecklistService,
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastService
  ) {
    {
      this.page.pageNumber = 0;
      this.page.pageSize = 10;
      this.page.totalRecords = 0;
    }


  }
  ngOnInit(): void {
    this.columns = [
      { prop: 'sName', name: 'Society Type' },
      { prop: 'rateOfProfit', name: 'Rate of Profit' },
      { prop: 'minumum', name: 'Minimum' },
      { prop: 'maximum', name: 'Maximum' }
    ];
    this.setPage({ offset: 0 });
    
  }
  search() {
    this.setPage({ offset: 0 });
  }
  
   onRowsPerPageChange() {
    this.page.pageNumber = 0;
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo: any) {
    const requestParams = {
      pageSize: this.page.pageSize,
      pageNumber: pageInfo.offset,
      keywords: this.filter.keyword || null,
  
    };

    this.finalchecklist.getAllSocietyType(requestParams).subscribe({
      next: (response) => {
        this.loading = false;

        if (response.status === 200) 
          {
           this.filteredRows = response.data;
          this.page.totalRecords = response.totalRecords;
          this.allDataLoaded = true;
        } else {
          this.rows = [];
          this.filteredRows = [];
          this.page.totalRecords = 0;
        }
      },

      error: (error) => {
        this.loading = false;
      }
    });
  }
  validateNumber(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  resetForm(): void {
    this.societyTypeList = {
      iSocietyTypeId: 0,
      rateOfProfit: null,
      minumum: null,
      maximum: null,
      sName: ''
    };

    if (this.formRef) {
      this.formRef.resetForm(this.societyTypeList);
    }
  }

  submitSocietyTypeForm(): void {
    this.finalchecklist.addSocietyType(this.societyTypeList).subscribe(
      (response) => {
        if (response.status === 200) {
          this.toastService.showSuccess(response.message);
       
          this.resetForm();
          window.location.reload();
    
        } else {
          this.toastService.showError(response.message);
        }
      },
      (error) => {
        this.toastService.showError(error.message);
      }
    );
  }
  
  formIsValid(): boolean {
    let isValid = true;
  
    if (!this.societyTypeList.sName ) {
      isValid = false;
    }
  
    if (
      this.societyTypeList.rateOfProfit == null ||
      this.societyTypeList.rateOfProfit < 0 ||
      this.societyTypeList.rateOfProfit > 999999
    ) {
      isValid = false;
    }
  
    if (
      this.societyTypeList.minumum == null ||
      this.societyTypeList.minumum < 0 ||
      this.societyTypeList.minumum > 999999
    ) {
      isValid = false;
    }
  
    if (
      this.societyTypeList.maximum == null ||
      this.societyTypeList.maximum < 0 ||
      this.societyTypeList.maximum > 999999
    ) {
      isValid = false;
    }
  
    if (
      this.societyTypeList.minumum != null &&
      this.societyTypeList.maximum != null &&
      this.societyTypeList.minumum > this.societyTypeList.maximum
    ) {
      isValid = false;
    }
  
    return isValid;
  }
  
  
  loadAuditors(id: number): void {

    this.finalchecklist.getSocietyTypeDetails(id).subscribe(
      (response: any) => {
        this.filteredData = response.data;
        this.societyTypeList = {
          iSocietyTypeId: this.filteredData.iSocietyTypeId || 0, 
          sName: this.filteredData.sName || '',
          rateOfProfit: this.filteredData.rateOfProfit || 0,
          minumum: this.filteredData.minumum || 0,
          maximum: this.filteredData.maximum || 0
        };
      },
      (error: { message: string; }) => {
        this.toastService.showError(error.message);
      }
    );
  }

  confirmDelete(): void {

    if (this.id !== null) {
      this.finalchecklist.deleteSocietyType(this.id).subscribe(
        (response) => {
          this.toastService.showSuccess(response.message);

          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
        (error) => {
          this.toastService.showError(error.message);

        }
      );
    }
  }

  openDeleteModal(id: number): void {
    this.id = id;
  }
}
